import { useEffect } from "react";

export const PageRedirectToLine = () => {
    //page hook
    const path = new URLSearchParams(window.location.search).get("path");

    const sanitizedPath = path?.replace(/^line:\/\//, "https://") ?? "";

    useEffect(() => {
        if (sanitizedPath) {
            window.open(sanitizedPath, "_self");
        }
    }, [sanitizedPath]);

    return <></>;
};
